import Vue from 'vue';

export default Vue.component('edit-project-cards', {
  template: require('./template.html'),
  name: 'edit-project-cards',
  props: ['droplet', 'show-edit-bubble'],
  data() {
    return {
      display: {
        visible: 0,
        loadMoreText: '',
        sortKey: false,
      },
    };
  },
  watch: {
    showEditBubble(open) {
      if (open) {
        this.setInitialValies();
      }
    },
  },
  methods: {
    setInitialValies() {
      this.display.visible = this.droplet.visible;
      this.display.loadMoreText = this.droplet.loadMoreText;
      this.display.sortKey = this.droplet.sortKey;
    },
    debounceSet(params) {
      this._debounce(() => {
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          key: params.key,
          val: this.display[params.key],
        });
        this.bouncePlugin();
      }, 300);
    },
    updateSortKey() {
      this._debounce(() => {
        const val = this.display.sortKey ? 'projectDate.date' : false;
        this.$store.dispatch('setDropletVal', {
          drp: this.droplet,
          val,
          key: 'sortKey',
        });
        this.bouncePlugin();
      }, 300);
    },
    async bouncePlugin() {
      await this.$vnode.context.destroyPlugin();
      this.$vnode.context.initPlugin();
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/project-cards/components/_edit-options/index.js